import moment from 'moment';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Clock from './Clock';
import HeaderButtons from './HeaderButtons';
import Logo from './Logo';
import Title from './Title';

import 'bootstrap/dist/css/bootstrap.min.css';
import { AppContainers } from './AppHeader.css.js';

const AppHeader = (props) => {
  const loginStatus = useSelector(store => store.loginManager.status); // 로그인 데이터
  const settings = useSelector(store => store.settings); // 장치 데이터

  useEffect(() => {
    if (loginStatus.pwDt !== null && settings.status === 'SUCCESS' &&
        moment.duration(moment(loginStatus.pwDt).diff(new Date())).asDays() < settings.setting.pwdUpdateTerm * -1) {
      alert('비밀번호를 변경한지 90일이 지났습니다. 비밀번호를 변경해주세요.');
    }
  }, [loginStatus])

  return(
    <AppContainers>
      <Logo/>
      <Title {...props}/>
      <Clock endPoint="/api/hello"/>
      <HeaderButtons {...props}/>
    </AppContainers>
  )
}

export default AppHeader;